export enum EntityType {
  SharedList = 1,
  Family = 2,
  Profile = 3,
  Form = 4,
}
